import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, type OnInit } from '@angular/core';
import { ApprovalSchemeService } from '@zaoblako/web/core/services/budget/approval-scheme.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { StandardSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/standard-dropdown/standard-single-select/standard-single-select.component';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { ApprovalSchemeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/approval-scheme/approval-scheme-find.dto';

/**
 * @deprecated Use `crm-standard-single-select` and `ApprovalSchemeService.dropdownDescriptorUrl`.
 */
@Component({
  selector: 'crm-approval-scheme-single-select',
  standalone: true,
  imports: [SingleSelectComponent, StandardSingleSelectComponent],
  templateUrl: './approval-scheme-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalSchemeSingleSelectComponent implements OnInit {
  @Input() public approvalSchemas: ApprovalSchemeFindInterface[] = [];
  @Input() public selectedApprovalScheme: ApprovalSchemeFindInterface | OnlyIdRequiredInterface<ApprovalSchemeFindInterface>;
  @Output() public selectedApprovalSchemeChange = new EventEmitter<ApprovalSchemeFindInterface>();
  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public loading = false;
  public useStandard = false;
  public readonly descriptorUrl: string;

  public constructor(
    approvalSchemeService: ApprovalSchemeService,
    private readonly globalService: GlobalService
  ) {
    this.descriptorUrl = approvalSchemeService.dropdownDescriptorUrl;
  }

  public ngOnInit(): void {
    this.useStandard = !this.customRequest && !!this.globalService.globalInfo?.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled;
  }

  public onSelected = (approvalScheme: ApprovalSchemeFindInterface): void => {
    this.selectedApprovalScheme = approvalScheme;
    this.selectedApprovalSchemeChange.emit(approvalScheme);
  };
}
